// 
import WebComponent from '../src/webComponents/WebComponent';
import $ from 'jquery';
import '../edeeshop/jquery.list-toggle';

export default class ListToggle extends WebComponent {
  enterDocument() {
  const {
	  listToggleContainer,
	  listToggleItem,
	  defaultLinesCount,
  } = this.props;

    $(this.element).listToggle({
		container: listToggleContainer || '.listToggle table',
		listItem: listToggleItem || 'tr',
		defaultLinesCount: parseInt(defaultLinesCount) || 3,
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/ListToggle.js